<template>
  <div>
    <b-form-group
      id="fieldsetItems"
      :label-cols="labelCols"
      breakpoint="md"
      :label="listLabel"
      label-for="listItems"
    >
      <b-row class="item-input" v-if="!isReadonly">
        <b-col>
          <b-form-input
            v-model="itemToAdd"
            name="inputAddItem"
            v-validate="itemValidation"
            :data-vv-as="itemValidationName"
            :class="{'input': true, 'text-danger': errors.has('inputAddItem') }"
            ref="inputAddItemRef"
            :placeholder="itemPlaceholder"
            v-on:keyup.enter.prevent="addItem()"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.first('inputAddItem')"
          >{{ itemValidationMessage || errors.first('inputAddItem') }}</span>
        </b-col>
        <b-col cols="1">
          <a v-on:click.prevent="addItem()">
            <i class="fa fa-plus-circle"></i>
          </a>
        </b-col>
      </b-row>
      <b-row class="list-group-items">
        <b-col cols="11">
          <b-list-group id="listItems">
            <b-list-group-item v-for="(value, index) in items" :key="value">
              {{value}}
              <div class="float-right" v-if="!isReadonly">
                <a v-on:click="$emit('remove', index)">
                  <i class="fa fa-minus-circle"></i>
                </a>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: "VItemList",
  props: {
    items: {
      required: true,
      type: Array
    },
    listLabel: {
      required: true,
      type: String
    },
    itemValidation: {
      required: true
    },
    itemValidationName: {
      required: true,
      type: String
    },
    itemValidationMessage: {
      required: false,
      type: String
    },
    itemPlaceholder: {
      required: false,
      type: String
    },
    isReadonly: {
      required: false,
      type: Boolean
    },
    labelCols: {
      required: false,
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      itemToAdd: ""
    };
  },
  methods: {
    addItem() {
      if ((!this.$refs.inputAddItemRef.$validator.errors ||
          this.$refs.inputAddItemRef.$validator.errors.items.length === 0) &&
          (this.$refs.inputAddItemRef.$validator.errors.items.find(
            x => x.field === "inputAddItem"
          ) === undefined) &&
        this.itemToAdd
      ) {
        this.$emit("add", this.itemToAdd);
        this.itemToAdd = "";
      }
    }
  }
};
</script>

<style lang="scss">
.list-group-item input {
  border-width: 0;
}

.item-input {
  padding-top: 0px !important;
  padding-bottom: 5px;
  div {
    padding-top: 0px !important;
    padding-bottom: 0px;
  }
  .col-1 {
    padding-left: 0;
  }
  i {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.list-group-items {
  padding-top: 0px !important;
  .list-group,
  .col-11 {
    padding-top: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VItemList.vue